import { axios } from '@/utils/request'

export default {
    create(user){
        return axios.post('/api/services/app/User/Create',user)
    },
    update(user){
        return axios.put('/api/services/app/User/Update',user)
    },
    delete(id){
        return axios.delete('/api/services/app/User/Delete?Id='+id)
    },
    get(id){
        return axios.get('/api/services/app/User/Get?Id='+id)
    },
    getAll(page){
        return axios.get('/api/services/app/User/GetAll',{params:page})
    },
    getRoles(){
        return axios.get('/api/services/app/User/GetRoles')
    },
    changePassword(input){
        return axios.post('/api/services/app/User/ChangePassword',input)
    },
    resetPassword(input){
        return axios.post('/api/services/app/User/resetPassword',input)
    },
    changeLanguage(input){
        return axios.post('/api/services/app/User/ChangeLanguage',input)
    },
    disabled(input){
        return axios.post('/api/services/app/User/Disabled',input)
    },
    active(input){
        return axios.post('/api/services/app/User/Active',input)
    },
    getBaseInfos(input){
        return axios.get('/api/services/app/User/GetBaseInfos',{params:input})
    },
    getSchools(){
        return axios.get('/api/services/app/User/GetSchools')
    },
    checkEmail(input){
        return axios.post('/api/services/app/User/CheckEmail',input)
    }
}